import { createRequiredValidators } from "@xo/client-common";
import { Type4Fraction } from "./Type4Fraction";

export function createType4FractionValidators() {
    return [
        ...createRequiredValidators<Type4Fraction>(["simpleField", "valueListField", "validatedField", "arrayField", "valueListArray", "validatedArrayField"]),
    ];
}
